<div class="pt-3" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3" *ngIf="serverError === null">
  <div class="rounded-table-wrapper rounded-table-tight table-responsive">
    <table class="table table-hover table-12px">

      <thead>
      <tr>
        <th scope="col" colspan="99" class="text-primary" style="font-size: 16px; padding-top: 8px; padding-bottom: 8px;">
          <button class="btn btn-sm btn-outline-primary float-right"
                  style="font-size: 12px; line-height: 12px;"
                  [routerLink]="['/membership-settings', 'discounts']">
            View All Membership Discounts
          </button>
          <span style="position: relative; top: 4px;">Association Membership Discounts</span>
        </th>
      </tr>
      <tr>
        <th scope="col">Type</th>
        <th scope="col">Code</th>
        <th scope="col">Name</th>
        <th scope="col">Amount</th>
        <th scope="col"></th>
      </tr>
      </thead>

      <tbody *ngIf="!loadingMembershipDiscounts">
      <tr *ngFor="let discount of membershipDiscountList">
        <td>{{ getMembershipDiscountApplyMethodDisplay(discount.discount_apply_method) }}</td>
        <td>
          <span *ngIf="discount.code">{{ discount.code }}</span>
          <span *ngIf="!discount.code" class="text-muted">None</span>
        </td>
        <td>
          <span *ngIf="discount.name">{{ discount.name }}</span>
          <span *ngIf="!discount.name" class="text-muted">None</span>
        </td>
        <td>
          <span *ngIf="discount.discount_type === MembershipDiscountType.currency">
            {{ orgConfig.formatCurrency(discount.amount) }}
          </span>
          <span *ngIf="discount.discount_type === MembershipDiscountType.percentage">
            {{ discount.amount }}%
          </span>
        </td>
        <td class="table-12px-button-cell">
          <a class="btn btn-sm btn-outline-primary table-12px-button float-right" type="button"
             [routerLink]="['/membership-settings', 'discounts', discount.id.toString()]">
            Edit
          </a>
        </td>
      </tr>
      <tr *ngIf="membershipDiscountList.length === 0">
        <td colspan="99" class="text-muted">No discounts</td>
      </tr>
      </tbody>

      <tbody *ngIf="loadingMembershipDiscounts">
      <tr>
        <td colspan="99" class="text-muted">Loading discounts...</td>
      </tr>
      </tbody>

    </table>
  </div>

  <div class="rounded-table-wrapper rounded-table-tight table-responsive">
    <table class="table table-hover table-12px">

      <thead>
      <tr>
        <th scope="col" colspan="99" class="text-primary" style="font-size: 16px; padding-top: 8px; padding-bottom: 8px;">
          <button class="btn btn-sm btn-outline-primary float-right"
                  style="font-size: 12px; line-height: 12px;"
                  [routerLink]="['/entry-pass-settings', 'discounts']">
            View All Entry Pass Discounts
          </button>
          <span style="position: relative; top: 4px;">Association Entry Pass Discounts</span>
        </th>
      </tr>
      <tr>
        <th scope="col">Type</th>
        <th scope="col">Code</th>
        <th scope="col">Name</th>
        <th scope="col">Amount</th>
        <th scope="col"></th>
      </tr>
      </thead>

      <tbody *ngIf="!loadingEntryPassDiscounts">
      <tr *ngFor="let discount of entryPassDiscountList">
        <td>{{ discount.is_automatic ? 'Automatic' : 'Code' }}</td>
        <td>
          <span *ngIf="discount.code">{{ discount.code }}</span>
          <span *ngIf="!discount.code" class="text-muted">None</span>
        </td>
        <td>
          <span *ngIf="discount.name">{{ discount.name }}</span>
          <span *ngIf="!discount.name" class="text-muted">None</span>
        </td>
        <td>
          <span *ngIf="discount.discount_type === EntryPassDiscountType.currency">
            {{ orgConfig.formatCurrency(discount.amount) }}
          </span>
          <span *ngIf="discount.discount_type === EntryPassDiscountType.percentage">
            {{ discount.amount }}%
          </span>
        </td>
        <td class="table-12px-button-cell">
          <a class="btn btn-sm btn-outline-primary table-12px-button float-right" type="button"
             [routerLink]="['/entry-pass-settings', 'discounts', discount.id.toString()]">
            Edit
          </a>
        </td>
      </tr>
      <tr *ngIf="entryPassDiscountList.length === 0">
        <td colspan="99" class="text-muted">No discounts</td>
      </tr>
      </tbody>

      <tbody *ngIf="loadingEntryPassDiscounts">
      <tr>
        <td colspan="99" class="text-muted">Loading discounts...</td>
      </tr>
      </tbody>

    </table>
  </div>

  <div class="rounded-table-wrapper rounded-table-tight table-responsive">
    <table class="table table-hover table-12px">

      <thead>
      <tr>
        <th scope="col" colspan="99" class="text-primary" style="font-size: 16px; padding-top: 8px; padding-bottom: 8px;">
          <button class="btn btn-sm btn-outline-primary float-right"
                  style="font-size: 12px; line-height: 12px;"
                  [routerLink]="['/events', 'setup', 'discounts']">
            View All Event Discounts
          </button>
          <span style="position: relative; top: 4px;">Association Event Discounts</span>
        </th>
      </tr>
      <tr>
        <th scope="col">Type</th>
        <th scope="col">Code</th>
        <th scope="col">Name</th>
        <th scope="col">Amount</th>
        <th scope="col"></th>
      </tr>
      </thead>

      <tbody *ngIf="!loadingEventDiscounts">
      <tr *ngFor="let discount of eventDiscountList">
        <td>{{ discount.is_automatic ? 'Automatic' : 'Code' }}</td>
        <td>
          <span *ngIf="discount.code">{{ discount.code }}</span>
          <span *ngIf="!discount.code" class="text-muted">None</span>
        </td>
        <td>
          <span *ngIf="discount.name">{{ discount.name }}</span>
          <span *ngIf="!discount.name" class="text-muted">None</span>
        </td>
        <td>
          <span *ngIf="discount.discount_type === EventDiscountType.currency">
            {{ orgConfig.formatCurrency(discount.amount) }}
          </span>
          <span *ngIf="discount.discount_type === EventDiscountType.percentage">
            {{ discount.amount }}%
          </span>
        </td>
        <td class="table-12px-button-cell">
          <a class="btn btn-sm btn-outline-primary table-12px-button float-right" type="button"
             [routerLink]="['/events', 'setup', 'discounts', discount.id.toString()]">
            Edit
          </a>
        </td>
      </tr>
      <tr *ngIf="eventDiscountList.length === 0">
        <td colspan="99" class="text-muted">No discounts</td>
      </tr>
      </tbody>

      <tbody *ngIf="loadingEventDiscounts">
      <tr>
        <td colspan="99" class="text-muted">Loading discounts...</td>
      </tr>
      </tbody>

    </table>
  </div>
</div>
